import { useState } from "react";
import { toast } from "sonner";
import { PlayCircle } from "lucide-react";
import { api, errMsg } from "@/lib/api";

export const DemoButton = ({ className = "", label = "Try the live demo", testId = "demo-btn" }) => {
  const [busy, setBusy] = useState(false);
  const start = async () => {
    setBusy(true);
    try {
      await api.post("/public/demo");
      window.location.assign("/app");
    } catch (e) {
      toast.error(errMsg(e));
      setBusy(false);
    }
  };
  return (
    <button onClick={start} disabled={busy} className={`flex items-center justify-center gap-2 transition-colors disabled:opacity-60 ${className}`} data-testid={testId}>
      <PlayCircle className="h-4 w-4" />
      {busy ? "Setting up your demo…" : label}
    </button>
  );
};
